<template>
  <v-card class="sale-success-card" flat>
    <div class="sale-success-card__status">
      <div class="sale-success-card__status-icon">
        <v-icon color="white" size="28">mdi-check-bold</v-icon>
      </div>
    </div>

    <div class="sale-success-card__headline">
      Venta #{{ saleIdDisplay }} exitosa.
    </div>

    <div v-if="invoiceErrorMessage" class="sale-success-card__invoice-warning">
      <div class="sale-success-card__invoice-warning-title">
        La venta se completó, pero la factura no pudo generarse.
      </div>
      <div class="sale-success-card__invoice-warning-message">
        {{ invoiceErrorMessage }}
      </div>
      <div class="sale-success-card__invoice-warning-help">
        Si tienes problemas con el timbrado, realiza la factura en el módulo de
        <strong>Administrador &gt; Facturación</strong>.
      </div>
    </div>

    <v-btn
      block
      large
      color="white"
      class="sale-success-card__action sale-success-card__action--primary"
      :loading="printingTicket"
      @click="$emit('reprint-ticket')"
    >
      <v-icon left small color="white">mdi-printer</v-icon>
      Imprimir Ticket de Venta
    </v-btn>

    <div v-if="invoiceResponse" class="sale-success-card__invoice-box">
      <v-btn
        block
        large
        color="white"
        class="sale-success-card__action sale-success-card__action--primary"
        @click="$emit('download-invoice')"
      >
        Descargar Factura (XML / PDF)
      </v-btn>
    </div>

    <div v-if="showCollectionTicket" class="sale-success-card__legal-box">
      <div class="sale-success-card__legal-title">
        Documento Legal Requerido
      </div>
      <v-btn
        color="primary"
        class="sale-success-card__legal-action"
        depressed
        :disabled="!canOpenCollectionTicket"
        @click="openCollectionTicketPreview"
      >
        <v-icon left small color="white">mdi-printer</v-icon>
        Imprimir Vale de Resguardo
      </v-btn>
    </div>

    <v-btn
      v-if="false"
      block
      large
      outlined
      class="sale-success-card__action"
      disabled
    >
      <v-icon left small>mdi-whatsapp</v-icon>
      Enviar Copia Digital (WhatsApp / Correo)
    </v-btn>

    <div class="d-flex justify-center">
        <v-btn
          large
          color="primary"
          @click="$emit('close')"
        >
          Listo - Nueva Venta
        </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'sale-success-actions',
  props: {
    saleId: {
      type: [Number, String],
      default: null,
    },
    showCollectionTicket: {
      type: Boolean,
      default: false,
    },
    printingTicket: {
      type: Boolean,
      default: false,
    },
    invoiceResponse: {
      type: Object,
      default: null,
    },
    invoiceErrorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    saleIdDisplay() {
      return this.saleId == null || this.saleId === '' ? '----' : this.saleId;
    },
    canOpenCollectionTicket() {
      return this.saleId != null && this.saleId !== '';
    },
  },
  methods: {
    openCollectionTicketPreview() {
      if (!this.canOpenCollectionTicket) return;

      const routeData = this.$router.resolve({
        name: 'resguardo-vale-ticket',
        params: { folio: String(this.saleId), mode: 'todas' },
      });

      const openedTab = window.open(routeData.href, '_blank');

      if (!openedTab) {
        this.$router.push({
          name: 'resguardo-vale-ticket',
          params: { folio: String(this.saleId) },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sale-success-card {
  border: 2px solid #8f96a3;
  border-radius: 24px;
  padding: 40px 28px 28px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f8fc 100%);
  box-shadow: 0 18px 40px rgba(23, 32, 63, 0.08);
}

.sale-success-card__status {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
}

.sale-success-card__status-icon {
  width: 54px;
  height: 54px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #8ceb1b 0%, #61da14 100%);
  box-shadow: 0 10px 24px rgba(100, 221, 23, 0.35);
}

.sale-success-card__headline {
  margin-bottom: 22px;
  text-align: center;
  color: #2d3656;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
}

.sale-success-card__invoice-warning {
  margin-bottom: 22px;
  padding: 16px 18px;
  border-radius: 16px;
  background: #fff8e6;
  border: 1px solid #f5d08a;
  color: #9a5b00;
}

.sale-success-card__invoice-warning-title {
  margin-bottom: 8px;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
}

.sale-success-card__invoice-warning-message {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  word-break: break-word;
}

.sale-success-card__invoice-warning-help {
  font-size: 14px;
  line-height: 1.4;
}

.sale-success-card__action {
  margin-bottom: 18px;
  min-height: 54px !important;
  border-radius: 14px;
  border-color: #2c467f !important;
  color: #2d3656 !important;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.sale-success-card__action--primary {
  border: 1px solid #e5e8f2 !important;
  box-shadow: 0 8px 18px rgba(28, 40, 82, 0.08);
}

.sale-success-card__legal-box {
  margin-bottom: 22px;
  padding: 14px 18px 18px;
  border: 2px solid #3b4d84;
  border-radius: 14px;
  text-align: center;
}

.sale-success-card__legal-title {
  margin-bottom: 10px;
  color: #20356b;
  font-size: 13px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.sale-success-card__legal-action {
  min-height: 40px !important;
  border-radius: 10px;
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0;
}

.sale-success-card__done {
  margin-top: 10px;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 600px) {
  .sale-success-card {
    padding: 28px 18px 20px;
    border-radius: 18px;
  }

  .sale-success-card__headline {
    font-size: 22px;
  }
}
</style>
